import { render, staticRenderFns } from "./MarketplaceSchemesComponent.vue?vue&type=template&id=5ba9ee96"
import script from "./MarketplaceSchemesComponent.vue?vue&type=script&lang=js"
export * from "./MarketplaceSchemesComponent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceSchemesComponent.vue?vue&type=style&index=0&id=5ba9ee96&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports